import React from 'react'
import moment from 'moment'
import Button from '../../../../../../components/buttons/buttons.component'
import PeriodInputs from '../../../../../../components/form-components/period-inputs.component'
import StyledFlexContainer from '../../../../../../components/containers/flex-container.component'
import { TextInput } from '../../../../../../components/form-components/inputs.component'
import { SelectInput } from '../../../../../../components/form-components/inputs.component'

const FormComponent = props => (
	<form noValidate onSubmit={props.handleSubmit}>
		<StyledFlexContainer>
			<SelectInput
				multi={false}
				className="col-3"
				id="dateFilterType"
				name="dateFilterType"
				label="Filtrar por data de"
				options={dateFilterTypeOptions}
				defaultValue={dateFilterTypeOptions[0]}
				onValueChange={({ value }) => onValueChange(value, props.formRef)}
				{...props}
			/>
			<PeriodInputs
				classNameTo="col-2"
				classNameFrom="col-2"
				classNameSelect="col-3"
				finalDate={props.finalDate}
				finalDateIsOutSideRange={finalDateIsOutSideRange.bind(
					null,
					props.formRef
				)}
				{...props}
			/>
			<SelectInput
				id="redeemed"
				multi={false}
				className="col-2"
				label="Resgate Pontos"
				options={redeemedOptions}
				defaultValue={redeemedOptions[0]}
				{...props}
			/>
		</StyledFlexContainer>
		<StyledFlexContainer>
			<TextInput
				id="clientName"
				maxLength={128}
				label="	Cliente"
				className="col-4"
				{...props}
			/>
			<TextInput
				maxLength={128}
				id="trackNumber"
				className="col-4"
				label="	Localizador"
				{...props}
			/>
			<SelectInput
				multi={false}
				id="pointsStatus"
				className="col-2"
				label="Situação Pontos"
				options={pointsStatusOptions}
				defaultValue={pointsStatusOptions[0]}
				{...props}
			/>
			<SelectInput
				multi={false}
				id="ticketStatus"
				className="col-2"
				label="Situação Passagem"
				options={ticketStatusOptions}
				defaultValue={ticketStatusOptions[0]}
				{...props}
			/>
		</StyledFlexContainer>
		<div
			style={{
				display: 'flex',
				justifyContent: 'flex-end',
				marginBottom: '4rem',
				marginTop: '25px'
			}}>
			<Button
				secondary
				type="button"
				onClick={props.exportReport}
				style={{ marginRight: '15px' }}
				data-permission="77C6748F8DAB7BF10861814B6C9638D7BF26F39B">
				Exportar
			</Button>
			<Button
				data-permission="858B812BB82816AD3D0986F96A1353FC35E539EB"
				primary
				type="submit">
				Consultar
			</Button>
		</div>
	</form>
)

function finalDateIsOutSideRange(formRef, value, initialDate) {
	const { dateFilterType } = formRef.current.state.values
	const momentTrip = moment()
		.add(1, 'M')
		.add(7, 'd')
	return value.isBefore(moment(initialDate, 'DD/MM/YYYY')) ||
		dateFilterType == 'Trip'
		? value.isAfter(momentTrip)
		: value.isAfter(
				moment()
					.add('d', 1)
					.subtract('ms', 1)
		  )
}

const onValueChange = (value, formRef) => {
	const { finalDate: currentFinalDate } = formRef.current.state.values
	const isOutsideRange = moment(currentFinalDate, 'YYYY-MM-DD').isAfter(
		moment()
	)
	if (value == 'Sale' && isOutsideRange) {
		formRef.current.refs.period.setFinalDate(moment().format('DD/MM/YYYY'))
	}
}

const dateFilterTypeOptions = [
	{ value: 'Sale', label: 'Venda' },
	{ value: 'Trip', label: 'Viagem' },
	{ value: 'Cancellation', label: 'Cancelamento' }
]

const pointsStatusOptions = [
	{ value: 'todos', label: 'Todos' },
	{ value: 'CreditedPoints', label: 'Pontos creditados' },
	{ value: 'UncreditedPoints', label: 'Pontos não creditados' },
	{ value: 'IneligiblePoints', label: 'Pontos não elegíveis' },
	{ value: 'UnprocessedPoints', label: 'Pontos não processados' }
]

const ticketStatusOptions = [
	{ value: 'Active', label: 'Ativa' },
	{ value: 'Canceled', label: 'Cancelada' }
]

const redeemedOptions = [
	{ value: 'all', label: 'Todos' },
	{ value: true, label: 'Sim' },
	{ value: false, label: 'Não' }
]

export default FormComponent
